import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';

/**
 * WarnMap 渲染器 - 渲染带告警的数据
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 */
const WarnMapRenderer = ({ params, config }) => {
  let _params = params;
  if (config.firstField) {
    _params = params[config.firstField];
  }

  return (
    <>
      {_params && Object.keys(_params)?.reverse().filter(i => {
        return Object.keys(config.fieldsMap)?.includes(i);
      })?.map((key, index) => (
        <Fragment key={`warn-${index}`}>
          {_params[key] && (
            <>
              {typeof _params[key] === 'object' ? (
                <>
                  {config.fieldsMap[key]._Label && (
                    <Form.Item label={config.fieldsMap[key]._Label} />
                  )}
                  {Object.keys(_params[key])?.map((ckey, cindex) => {
                    const content = typeof (_params[key][ckey]) === 'object'
                      ? _params[key][ckey][config.fieldsMapContent]
                      : _params[key][ckey];

                    let warnList = [];
                    if (ckey === 'WarnInfos') {
                      const WarnInfos = _params[key][ckey];
                      Object.keys(WarnInfos)?.forEach(warn => {
                        if (WarnInfos[warn] > 0) {
                          warnList.push(config.warnsList[warn]);
                        }
                      });
                    }

                    return (
                      <Fragment key={`ckey-${cindex}`}>
                        {_params[key][ckey] && config.fieldsMap[key][ckey] && content && (
                          <Form.Item label={config.fieldsMap[key][ckey]}>
                            {content}
                          </Form.Item>
                        )}
                        {warnList.length > 0 && warnList.map((warns, windex) => (
                          <Form.Item
                            key={`warn-item-${windex}`}
                            active
                            label={`告警${windex + 1}`}
                            className="unv-form__item-group"
                          >
                            <p className="mb-10"><span>{warns}</span></p>
                          </Form.Item>
                        ))}
                      </Fragment>
                    );
                  })}
                </>
              ) : (
                <Form.Item label={config.fieldsMap[key]}>
                  {_params[key]}
                </Form.Item>
              )}
            </>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default WarnMapRenderer;
